import React, { useEffect } from "react";
import styles from "../../../styles.module.scss";
import { SchedulePipelinesForm } from "@pages/workflow-page/SchedulePipelinesForm";
import { _canvasdagFormInitialValues } from "@pages/workflow-page/utils";
import { WorkflowCanvasTabInfo } from "@store/canvas";
import { InPageSpinner } from "@components/spinners/in-page-spinner";
import { DataSourceHandler } from "@api/data-source-handler";
import { useSelector } from "react-redux";
import { RootState } from "@store/types";
import { errorAlert } from "@components/toastify/notify-toast";
import { isEmpty } from "lodash";

interface HierarchyFormProps {
    activeStep: number;
    isLoadingElements: boolean;
    isEditForm: boolean;
    setActiveStep: (step: number) => void;
    handleOnSubmit: (values: any) => void;
    intialValuesScheduleFormState: any;
    isDisableRequrring: boolean;
    startEndTimePayloadString:string;
    selectedScheduleTimingInfo:string;
}

const HierarchyScheduleForm: React.FC<HierarchyFormProps> = ({
    activeStep,
    setActiveStep,
    isEditForm,
    isLoadingElements,
    intialValuesScheduleFormState,
    handleOnSubmit,
    isDisableRequrring,
    startEndTimePayloadString,
    selectedScheduleTimingInfo
}) => {
    // const { envVariables: Env } = useSelector((store:RootState)=> store.AccountReducer);
    // const [startEndTimeIntervalLIst, setStartEndTimeIntervalList] = React.useState<string[]>([]);
    const handleScheduleRhsFormSubmit = (values: WorkflowCanvasTabInfo['scheduleInfoForDag']) => {
        handleOnSubmit(values);
    }

    const handleScheduleDagWorkflow = (values?: WorkflowCanvasTabInfo['scheduleInfoForDag']) => {
        const tmp = "";
    }

    // useEffect(() => {
    //     if(!isEmpty(startEndTimePayloadString)){
    //         DataSourceHandler.GetStartEndTimeRangeList(
    //             `${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, 
    //             startEndTimePayloadString,
    //             (response: any) => {
    //               if(response){
    //                setStartEndTimeIntervalList(response);
    //               }
    //             },
    //             (error: any) => {
    //               errorAlert(error);
    //             }
    //         );
    //     }
    // }, [Env]);

    return (
        <>
            <div className={styles.jsonHierarchyScheduleForm}>
                <SchedulePipelinesForm
                    dagFormInitialValues={intialValuesScheduleFormState}
                    handleScheduleDagWorkflow={handleScheduleDagWorkflow}
                    handleScheduleRhsFormSubmit={
                        handleScheduleRhsFormSubmit
                    }
                    isJobScheduled={false}
                    isHierarchy={true}
                    // startEndTimeIntervalLIst={startEndTimeIntervalLIst}
                    isDagEnv={true}
                    selectedScheduleTimingInfo={selectedScheduleTimingInfo}
                    isDisableRequrring={isDisableRequrring}
                    btns={
                        <div className={styles.hierarchyFormFooter}>
                            <button type="button" disabled={isLoadingElements} className="btn btn-grey btn-md" onClick={() => { setActiveStep(activeStep - 1); }}>
                                Back
                            </button>
                            <button className="btn btn-yellow btn-md" >
                                {isLoadingElements ?
                                    <InPageSpinner size="XSmall" color="black" />
                                    :
                                    <span>{!isEditForm ? "Publish" : "Update"}</span>
                                }
                            </button>
                        </div>
                    }
                />
            </div>
        </>
    );
};

export default HierarchyScheduleForm;
